/**
 * @generated SignedSource<<d89dcaf579ad6a615437c20f41a0ab88>>
 * @relayHash a59fcaa6ed85f8397605fc22e793bc02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f80ddd4211ffa1e184e6abd042d761c08f43154ad5e6584f16c5e1c2d52f4d0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JswBoardsRefactoredRefetchQuery$variables = {
  cloudId: string;
  entityAri: string;
  noOfBoardsToFetch: number;
  ownerAri: string;
  projectKey: string;
};
export type JswBoardsRefactoredRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JswBoardsRefactored">;
};
export type JswBoardsRefactoredRefetchQuery = {
  response: JswBoardsRefactoredRefetchQuery$data;
  variables: JswBoardsRefactoredRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noOfBoardsToFetch"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "entityAri",
  "variableName": "entityAri"
},
v3 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "boardId"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "JswBoardsRefactoredRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "noOfBoardsToFetch",
            "variableName": "noOfBoardsToFetch"
          },
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JswBoardsRefactored"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JswBoardsRefactoredRefetchQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "noOfBoardsToFetch"
                  }
                ],
                "concreteType": "JiraBoardConnection",
                "kind": "LinkedField",
                "name": "boards",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraBoard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "JiraNavigationItem",
                                "abstractKey": "__isJiraNavigationItem"
                              },
                              (v8/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "type": "JiraBoard"
                  },
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "softwareBoardCount"
              }
            ]
          }
        ]
      },
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visible"
                  }
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "6f80ddd4211ffa1e184e6abd042d761c08f43154ad5e6584f16c5e1c2d52f4d0",
    "metadata": {},
    "name": "JswBoardsRefactoredRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ec07e020c7e43fbb502416050eaf237f";

export default node;
